import {
  ExhibitorStatisticsFilter,
  OrganiserStatisticsFilter,
  PlaceManagerStatisticsFilter,
  TourismOperatorStatisticsFilter,
} from "@ac-expo/api-types";

export const statisticsQueryKeys = {
  all: ["statistics"] as const,
  organiser: (filter: OrganiserStatisticsFilter) =>
    [...statisticsQueryKeys.all, "organiser", filter] as const,
  placeManager: (filter: PlaceManagerStatisticsFilter) =>
    [...statisticsQueryKeys.all, "place-manager", filter] as const,
  exhibitor: (filter: ExhibitorStatisticsFilter) =>
    [...statisticsQueryKeys.all, "exhibitor", filter] as const,
  tourismOperator: (filter: TourismOperatorStatisticsFilter) =>
    [...statisticsQueryKeys.all, "tourism-operator", filter] as const,
};
